"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Basic_1 = require("../Basic");
const utils_1 = require("../utils");
class Nano extends Basic_1.Basic {
    constructor(options = {}) {
        super(options);
        this.DEFAULT_TTL = 30 * 1000;
        this.options = super.options || options;
        this.options.ttl = this.options.ttl || this.DEFAULT_TTL;
        this.options.ttlInterval = this.options.ttlInterval === undefined ? Math.floor(this.options.ttl / 3) : this.options.ttlInterval;
        this.options.renewOnGet = !!this.options.renewOnGet;
        if (this.options.ttlInterval) {
            this._interval = setInterval(() => this._expirationChecker(), this.options.ttlInterval);
            /* istanbul ignore next */
            if (typeof this._interval.unref === 'function') {
                this._interval.unref();
            }
            /* istanbul ignore next */
            if (process.env.NODE_ENV === 'test') {
                setTimeout(() => {
                    clearInterval(this._interval);
                }, 200);
            }
        }
    }
    _expirationChecker() {
        const now = Date.now();
        super._forEach((element, key) => {
            if (!element.options.noExpire && (!element.expireAt || element.expireAt < now)) {
                return this._expireKey(key, element);
            }
        });
    }
    _expireKey(key, element) {
        return super._delete(key);
    }
    _toCacheElement(value, options) {
        options.ttl = options.ttl || this.options.ttl || this.DEFAULT_TTL;
        options.renewOnGet = !!options.renewOnGet;
        options.noExpire = !!options.noExpire;
        return {
            value,
            expireAt: Date.now() + options.ttl,
            options
        };
    }
    _fromCacheElement(element) {
        return element.value;
    }
    add(key, value, options = {}) {
        if (value === undefined) {
            console.warn(`Cache may not work properly with undefined values! Key '${key}'.`);
        }
        const result = this._add(key, this._toCacheElement(value, options));
        if (utils_1.isPromise(result)) {
            return result.then((element) => {
                return this._fromCacheElement(element);
            });
        }
        return this._fromCacheElement(result);
    }
    set(key, value, options = {}) {
        if (value === undefined) {
            console.warn(`Cache may not work properly with undefined values! Key '${key}'.`);
        }
        const result = this._set(key, this._toCacheElement(value, options));
        if (utils_1.isPromise(result)) {
            return result.then(() => value);
        }
        return value;
    }
    get(key) {
        const result = this._get(key);
        const callback = (element) => {
            if (element === undefined) {
                return undefined;
            }
            const value = this._fromCacheElement(element);
            const options = element.options;
            const renewOnGet = options.renewOnGet !== undefined ? !!options.renewOnGet : !!this.options.renewOnGet;
            if (renewOnGet) {
                options.ttl = options.ttl || this.options.ttl || this.DEFAULT_TTL;
                this.set(key, value, options);
            }
            return value;
        };
        if (utils_1.isPromise(result)) {
            return result.then(callback);
        }
        return callback(result);
    }
    has(key) {
        return this._has(key);
    }
    delete(key) {
        return this._delete(key);
    }
    forEach(callback, thisArg) {
        if (thisArg !== undefined) {
            callback = callback.bind(thisArg);
        }
        return super._forEach((element, key, map) => callback(this._fromCacheElement(element), key, map));
    }
    clear() {
        super._forEach((element, key) => this._expireKey(key, element));
    }
}
exports.Nano = Nano;
exports.default = Nano;
//# sourceMappingURL=index.js.map